import React from 'react';
import Icon from '../../../components/AppIcon';

const typeConfig = {
  search: { icon: 'Search', color: '#00D4FF', label: 'Search' },
  analysis: { icon: 'Sparkles', color: '#AA88FF', label: 'Analysis' },
  view: { icon: 'Eye', color: '#00FF88', label: 'Viewed' },
  save: { icon: 'Bookmark', color: '#FFAA00', label: 'Saved' },
  compare: { icon: 'GitCompare', color: '#FF8844', label: 'Compared' },
  report: { icon: 'FileText', color: '#FF4444', label: 'Report' },
};

const ActivityItem = ({ activity, isLast }) => {
  const config = typeConfig?.[activity?.type] || typeConfig?.view;
  return (
    <div className="flex gap-4">
      <div className="flex flex-col items-center">
        <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: `${config?.color}20`, border: `1px solid ${config?.color}40` }}>
          <Icon name={config?.icon} size={16} color={config?.color} />
        </div>
        {!isLast && <div className="w-px flex-1 mt-2" style={{ background: 'rgba(255,255,255,0.08)', minHeight: 24 }} />}
      </div>
      <div className="flex-1 pb-4">
        <div className="bg-card rounded-xl border border-border p-4 hover:border-primary/20 transition-colors">
          <div className="flex items-start justify-between gap-2 mb-1">
            <div>
              <span className="text-xs font-medium px-2 py-0.5 rounded-full mr-2" style={{ background: `${config?.color}15`, color: config?.color }}>{config?.label}</span>
              <span className="font-medium text-foreground text-sm">{activity?.title}</span>
            </div>
            <span className="text-xs text-muted-foreground flex-shrink-0">{activity?.time}</span>
          </div>
          {activity?.detail && <p className="text-xs text-muted-foreground mt-1">{activity?.detail}</p>}
          {activity?.tags && (
            <div className="flex flex-wrap gap-1 mt-2">
              {activity?.tags?.map((tag, i) => (
                <span key={i} className="text-xs px-2 py-0.5 rounded bg-muted text-muted-foreground">{tag}</span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityItem;
